import React, { useRef, useState } from "react";
import CustomizeDashboard from "../../components/CustomizeDashboard";
import { localStorageHandler, submitBrandingHandler } from "../../utils/helpers";
import { CONSTANTS } from "../../constants/Constants";
import { checkoutSession } from "../../services/api/packages";
import { useToastContext } from "../../context/ToastContext";
import { useGlobalContext } from "../../context/GlobalContext";

export interface ThemePayloadProps {
  PrimaryColor: string,
  SecondaryColor: string,
  TertiaryColor: string,
  CompanyLogo: File | null
}
const DashboardSetup: React.FC = () => {
  const { showToast } = useToastContext()
  const { setIsLoading, isLoading } = useGlobalContext()
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [themePayload, setThemePayload] = useState<ThemePayloadProps>({
    PrimaryColor: CONSTANTS.APP_DEFAULT_COLORS.PRIMARY_COLOR,
    SecondaryColor: CONSTANTS.APP_DEFAULT_COLORS.SECONDARY_COLOR,
    TertiaryColor: CONSTANTS.APP_DEFAULT_COLORS.TERTIARY_COLOR,
    CompanyLogo: null
  })

  const themeChangeHandler = (e: Event) => {
    let target = e.target as HTMLInputElement
    let name = target.name
    let value = target.value
    if (target.type === "file" && target.files) {
      setThemePayload({ ...themePayload, CompanyLogo: target?.files[0] });
    } else if (target.ariaLabel === "cross") {
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      setThemePayload({ ...themePayload, CompanyLogo: null })
    } else {
      setThemePayload({ ...themePayload, [name]: value })
    }
  }

  const redirectionHandler = async (isSubmit: boolean) => {
    try {
      setIsLoading(true)
      const baseURL = window.location.origin;
      let isPackageSelected = localStorageHandler(
        "get",
        CONSTANTS.LOCAL_STORAGE_KEYS.PACKAGE_PLAN
      );
      let userDetail: any = localStorageHandler(
        "get",
        CONSTANTS.LOCAL_STORAGE_KEYS.USER_TXT
      );

      if ((isPackageSelected) && userDetail) {
        let res = await checkoutSession({
          customerEmail: userDetail?.user?.email,
          successUrl: `${baseURL}/thank-you`,
          cancelUrl: `${baseURL}/login`,
        });
        if (!res.url.success) {
          showToast(res?.url?.data, "error")
        } else {
          if (isSubmit) {
            await submitBrandingHandler(themePayload)
          }
          window.location.href = res.url.data
        }
      } else {

        if (isSubmit) {
          await submitBrandingHandler(themePayload)
        }
        window.location.href = "/dashboard"
      }
      setIsLoading(false)
    } catch (e: any) {
      showToast(e.response.data.message, "error")
      setIsLoading(false)
    }
  };
  return (
    <div className="min-h-screen flex justify-center items-center">
      <CustomizeDashboard
        themeChangeHandler={themeChangeHandler}
        continueHandler={() => redirectionHandler(true)}
        skipHandler={() => redirectionHandler(false)}
        themePayload={themePayload}
        isLoading={isLoading}
        reference={fileInputRef}
        isLogoRequired={true}
      />
    </div>
  );
};

export default DashboardSetup;
